import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this ebook really for absolute beginners with no caregiving experience?',
  a: 'Yes. The Age-in-Place Blueprint is designed for adult children and families who have never managed senior care or studied aging protocols. We start from basic aging science and build everything step by step into complete daily care frameworks.'
}, {
  q: "Can I learn even if my parent has a complex condition like Alzheimer's or Parkinson's?",
  a: 'Absolutely. Volume 3 (The Expert Care Companion) covers all major senior conditions with specific daily management protocols. Each condition gets its own framework adapted to your home.'
}, {
  q: 'Are the protocols and routines actually useful, or just theoretical examples?',
  a: 'Every single protocol has been tested with real families and real seniors. The 30-day calendar, daily trackers and weekly routines are immediately applicable. You can start today and see results by week 2.'
}, {
  q: 'Does the ebook include assessment guidance and tips to avoid falls and hospitalization?',
  a: 'Yes. The entire system is built around prevention. The Fall-Proof Home Audit bonus alone has saved families thousands in emergency room visits. Every volume includes red-flag warnings and early-detection protocols.'
}, {
  q: 'How soon will I see real results with my parent?',
  a: 'Most caregivers report behavioral improvements in 7-10 days and measurable health improvements (better sleep, more mobility, clearer thinking) by week 3. The system is designed for fast visible wins.'
}, {
  q: 'Do I need other courses or can I just use this system alone?',
  a: 'This is a complete standalone system. You do not need anything else. Every piece is integrated: nutrition feeds cognition, exercise prevents falls, caregiver wellness sustains the whole system.'
}, {
  q: "What if I don't have 30 minutes every day to study?",
  a: 'The system is modular. You can study 10 minutes a day, one protocol at a time. The 5 bonuses can be consumed in 5-minute chunks. Real caregivers have built complete systems in 20 minutes daily over 30 days.'
}, {
  q: 'Is there support if I get stuck or have questions about managing a specific condition?',
  a: 'Yes. The Age-in-Place Blueprint community includes elder-care professionals, gerontologists and experienced caregivers who review your specific situation and provide guidance. Access included with purchase.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-57" data-mp="2ylibf9rj583z">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-58" data-mp="2ukyg8bqioekh">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-59" data-mp="1n9ptp643xuri">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-60" data-mp="3uu6g84sv8igb">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-61" data-mp="2nrkwpgag2gd" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-62" data-mp="7oyp6ej82jia">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-63" data-mp="mdle97ynipmp">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-64" data-mp="qf6pkovjevus" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-65" data-mp="qdlt2tpnx2ua" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-66" data-mp="vdzzy8fj26qq">
                  <div className="overflow-hidden" data-id="element-67" data-mp="2x77evgr8amc3">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-68" data-mp="2x7za2qgwyi1u">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}